/** Deterministic random numbers for the simulation (mulberry32). Same seed, same life. */
export class Rng {
  private s: number;
  constructor(seed: number) { this.s = seed >>> 0 || 1; }

  next(): number {
    let t = (this.s = (this.s + 0x6d2b79f5) >>> 0);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  range(a: number, b: number) { return a + this.next() * (b - a); }
  int(a: number, b: number) { return Math.floor(this.range(a, b + 1)); }
  chance(p: number) { return this.next() < p; }
  pick<T>(xs: readonly T[]): T { return xs[Math.floor(this.next() * xs.length)]; }
  /** roughly normal around 0.5 (sum of three uniforms) */
  bell() { return (this.next() + this.next() + this.next()) / 3; }
  weighted<T>(xs: readonly (readonly [T, number])[]): T {
    let r = this.next() * xs.reduce((s, [, w]) => s + w, 0);
    for (const [x, w] of xs) if ((r -= w) <= 0) return x;
    return xs[xs.length - 1][0];
  }
  /** a few distinct items */
  sample<T>(xs: readonly T[], n: number): T[] {
    const pool = [...xs], out: T[] = [];
    while (out.length < n && pool.length) out.push(pool.splice(Math.floor(this.next() * pool.length), 1)[0]);
    return out;
  }
}

export const newSeed = () => (Math.random() * 2 ** 32) >>> 0;
